import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-safety",
  "use": "rt-portal-safety-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-portal-safety\"><defs><style type=\"text/css\"></style></defs><path d=\"M849.7 198.8L526.8 86.1c-4-1.4-9.3-2-14.7-2-5.4 0-10.7 0.7-14.7 2L174.5 198.8c-8.1 2.7-14.7 12.1-14.7 20.6v471.8c0 8.6 5.6 19.9 12.3 25.2L499.7 938c3.4 2.6 7.8 4 12.3 4s9-1.4 12.3-4L852 716.4c6.7-5.3 12.3-16.6 12.3-25.2V219.5c0.1-8.6-6.5-17.9-14.6-20.7z m-55.4 473.7L512.1 858.7 229.9 672.5V254.1l282.2-98.9 282.2 98.9v418.4z\" p-id=\"2767\" fill=\"#A9C2E8\" /><path d=\"M407.1 474.8c-2.9-4-7.6-6.4-12.7-6.4h-53.8c-6.3 0-10 7.2-6.3 12.4l123.1 169.4c6.2 8.6 19.1 8.6 25.3 0l207-285c3.7-5.2 0-12.4-6.3-12.4h-53.8c-5 0-9.7 2.4-12.7 6.4L470.1 561.6l-63-86.8z\" p-id=\"2768\" fill=\"#A9C2E8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/safety.svg
// module id = 1300
// module chunks = 116